// block.js

const { registerBlockType } = wp.blocks;
const {
  PanelBody,
  TextControl,
  SelectControl,
  ToggleControl,
  RangeControl,
} = wp.components;
const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { __ } = wp.i18n;
const { ServerSideRender } = wp.editor;

// Import our CSS files
/*import './style.scss';*/
import "../editor.scss";

registerBlockType("ew-block/ew-archive", {
  title: "EW Archive",
  icon: "portfolio",
  category: "ew-block",
  edit: (props) => {
    const { attributes, className, setAttributes, isSelected } = props;
    const {
      title,
      limit,
      type,
      post_type,
      order,
      format,
      before,
      after,
      show_post_count,
    } = attributes;

    // ensure the block attributes matches this plugin's name
    return (
      <Fragment>
        <InspectorControls>
          <PanelBody>
            <TextControl
              label={__("Title")}
              value={title}
              onChange={(title) => setAttributes({ title })}
            />
            <RangeControl
              label="Limit"
              value={limit}
              onChange={(limit) => setAttributes({ limit })}
              min={1}
              max={30}
            />
            <SelectControl
              label={__("Select type")}
              value={type} // e.g: value = [ 'a', 'c' ]
              onChange={(type) => setAttributes({ type })}
              options={[
                { value: "alpha", label: "Alphabetical" },
                { value: "daily", label: "Daily" },
                { value: "monthly", label: "Monthly" },
                { value: "postbypost", label: "Post by Post" },
                { value: "weekly", label: "Weekly" },
                { value: "yearly", label: "Yearly" },
              ]}
            />
            <SelectControl
              label={__("Post type")}
              value={post_type} // e.g: value = [ 'a', 'c' ]
              onChange={(post_type) => setAttributes({ post_type })}
              options={[{ value: "post", label: "Post" }]}
            />
            <SelectControl
              label={__("Order")}
              value={order} // e.g: value = [ 'a', 'c' ]
              onChange={(order) => setAttributes({ order })}
              options={[
                { value: "asc", label: "Ascending" },
                { value: "desc", label: "Descending" },
              ]}
            />
            <SelectControl
              label={__("Display as")}
              value={format} // e.g: value = [ 'a', 'c' ]
              onChange={(format) => setAttributes({ format })}
              options={[
                { value: "custom", label: "Plain" },
                { value: "html", label: "List" },
                { value: "option", label: "Dropdown" },
              ]}
            />
            <TextControl
              label={__("Before")}
              value={before}
              onChange={(before) => setAttributes({ before })}
            />
            <TextControl
              label={__("After")}
              value={after}
              onChange={(after) => setAttributes({ after })}
            />
            <ToggleControl
                label={ __( 'Show count?' ) }
                checked={ show_post_count } 
                onChange={ (show_post_count) => setAttributes({show_post_count}) }
            />
          </PanelBody>
        </InspectorControls>
        <ServerSideRender block="ew-block/ew-archive" attributes={attributes} />
      </Fragment>
    );
  },

  save() {
    // Rendering in PHP
    return null;
  },
});
